import { Link as RouterLink, useParams } from "react-router-dom";
import { Box, Breadcrumbs, Link, Stack, Typography } from "@mui/material";
import { PageHeading, container } from "@aeriosiq/ui";

import { TimeTrackingConfigCard } from "./TimeTrackingConfigCard.js";
// DL-01 — the owner's "customers may download full-resolution images" switch.
import { CustomerImageDownloadCard } from "../../projects/settings/CustomerImageDownloadCard.js";

/**
 * TT-03 — `/projects/:projectId/settings`. Mockup screen D's frame.
 *
 * The project detail page IS the edit wizard (Basics → Parties → Parks →
 * Overview), so there was no settings surface to hang a commercial card on.
 * Rather than wedge pricing into a wizard step — where it would be one form
 * among four and would have to participate in the stepper's dirty-state — this
 * adds the settings page the mockup URL already assumed.
 *
 * It holds exactly one card today. That is the point: the next per-project
 * setting has somewhere to land that is not the wizard.
 */
export function ProjectSettingsPage() {
  const { projectId = "" } = useParams<{ projectId: string }>();

  return (
    <Box sx={{ maxWidth: container.app, mx: "auto", p: 3, pb: 6 }}>
      <Breadcrumbs sx={{ mb: 1 }}>
        <Link component={RouterLink} to="/projects" underline="hover">
          Projects
        </Link>
        <Link
          component={RouterLink}
          to={`/projects/${encodeURIComponent(projectId)}`}
          underline="hover"
        >
          Project
        </Link>
        <Typography color="text.primary">Settings</Typography>
      </Breadcrumbs>

      <PageHeading>Project settings</PageHeading>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Commercial configuration that applies to everything booked on this
        project.
      </Typography>

      <Stack spacing={3}>
        <TimeTrackingConfigCard projectId={projectId} />
        <CustomerImageDownloadCard projectId={projectId} />
        <Typography variant="body2">
          <Link
            component={RouterLink}
            to={`/projects/${encodeURIComponent(projectId)}/time-trackings`}
          >
            Review this project&apos;s time trackings →
          </Link>
        </Typography>
      </Stack>
    </Box>
  );
}
